import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { message, Modal } from "antd";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";
import { LeaveTypeEnumLabel } from "Constants/Enums/LeavePolicyEnum";

export default function TimeOffService() {
  const [showDetail, setShowDetail] = useState(true);
  const [showAddPolicy, setShowPolicy] = useState(true);
  const [leavePolicies, setLeavePolicies] = useState([]);
  const [policyDetails, setPolicyDetails] = useState([]);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadedData, setLoadedData] = useState(false);
  const [chartData, setChartData] = useState({
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: [
      {
        label: "Leaves Taken",
        color: "info",
        data: [],
      },
    ],
  });

  // FIXED: Use useCallback to memoize the function
  const fetchLeavePolicies = useCallback(async () => {
    try {
      const response = await axiosInstance.get(API.leavePolicy.getCurrentYearList);
      setLeavePolicies(response.data);
    } catch (error) {
      console.error("Error fetching leave policies:", error);
    }
  }, []); // Empty dependency array since it doesn't depend on any state

  // Fixed chart data fetching
  const fetchChartData = useCallback(async () => {
    try {
      const res = await axiosInstance.get(API.leaveRequest.getAll);

      // Initialize monthly counts
      const monthCounts = Array(12).fill(0);
      let hasValidData = false;

      res.data.forEach((leave, i) => {
        try {
          //  Use correct field from API
          const startDateStr =
            leave.fromDate || leave.leaveStartDate || leave.startDate || leave.date;

          if (!startDateStr) {
            return;
          }

          const startDate = new Date(startDateStr);
          if (isNaN(startDate.getTime())) {
            return;
          }

          //  Use totalDays if available (so longer leaves count properly)
          const month = startDate.getMonth();
          const totalDays = leave.totalDays || 1;
          monthCounts[month] += totalDays;
          hasValidData = true;
        } catch (error) {
          console.error("Error processing leave date:", error, leave);
        }
      });

      setChartData({
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        datasets: [
          {
            label: "Leaves Taken",
            color: "info",
            data: monthCounts,
          },
        ],
      });
    } catch (error) {
      console.error("❌ Error fetching leave data:", error);
      // Optional fallback data
      setChartData({
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        datasets: [
          {
            label: "Leaves Taken",
            color: "info",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
      });
    }
  }, []);

  // FIXED: Fetch leave policies on mount - only once
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await Promise.all([fetchLeavePolicies(), fetchChartData()]);
        setLoadedData(true);
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [fetchLeavePolicies, fetchChartData]);

  // FIXED: Fetch policy details only when selectedPolicy changes
  useEffect(() => {
    const fetchPolicyDetails = async () => {
      if (selectedPolicy) {
        try {
        } catch (error) {
          console.error(`Error fetching details for policy '${selectedPolicy}':`, error);
          toast.error(`Error fetching details for policy '${selectedPolicy}'`);
        }
      }
    };

    fetchPolicyDetails();
  }, [selectedPolicy]); // Only depends on selectedPolicy

  const getLeaveTypeLabel = (leaveType) => {
    return LeaveTypeEnumLabel[leaveType] || `Leave Type ${leaveType}`;
  };

  const handleDetail = async (policy) => {
    setSelectedPolicy(policy);
    setShowDetail(false);

    // Set policy details with formatted leave type
    setPolicyDetails([
      {
        ...policy,
        leaveTypeLabel: getLeaveTypeLabel(policy.leaveType),
      },
    ]);
  };

  const handleAddPolicy = () => {
    setShowPolicy(false);
    setShowDetail(true);
  };

  const handlePolicySubmissionSuccess = () => {
    setShowPolicy(true);
    setShowDetail(true);
    fetchLeavePolicies();
    fetchChartData();
  };

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

 

  return {
    expanded,
    toggleExpanded,
    showDetail,
    showAddPolicy,
    leavePolicies,
    policyDetails,
    handleDetail,
    getLeaveTypeLabel,
    handleAddPolicy,
    handlePolicySubmissionSuccess,
    loadedData,
    loading,
    chartData,
    fetchChartData,
  };
}
